import React from "react";
import { Phone } from "lucide-react";
import { contact } from "../mock";

// Floating "Call Us" button — fixed bottom-right, taps to dial.
const CallButton = () => (
  <a
    href={`tel:${contact.phoneRaw}`}
    aria-label={`Call us on ${contact.phone}`}
    className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 pl-4 pr-5 py-3 rounded-full shadow-lg text-white text-[12px] tracking-[0.16em] uppercase font-semibold transition-all duration-300 hover:brightness-110 hover:shadow-xl"
    style={{ backgroundColor: "#E97B2B" }}
  >
    <Phone size={17} strokeWidth={2.4} />
    Call Us
  </a>
);

export default CallButton;
